<template>
    <ResizeScale>
        <template slot="slot">
            <section id="join-start-section" class="layout layout-scale">
                <div class="header">
                    <div class="text-center md:hidden">
                        <HeaderLogo
                            :warning-message="$t('playlive_alert_leave')"
                            logo-width="12"
                            color="var(--ui-color)"
                            shadow="var(--question-shadow-color)"
                            class="logo inline-block"
                        ></HeaderLogo>
                    </div>
                    <div class="hidden md:flex">
                        <HeaderLogo
                            :warning-message="$t('playlive_alert_leave')"
                            color="var(--ui-color)"
                            shadow="var(--question-shadow-color)"
                            logo-width="12"
                        ></HeaderLogo>
                        <div class="flex-1 flex flex-col items-end justify-start">
                            <p
                                class="theme-ui-text-color theme-question-shadow text-center uppercase font-size-22 font-bold text-white mt-4"
                            >
                                {{ $t('join_start_welcome') }} {{ name }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="content">
                    <div class="max-w-lg mx-auto content-container">
                        <p
                            class="theme-question-text-color theme-question-shadow block md:hidden text-center uppercase font-size-22 font-bold text-white pt-4 mb-8"
                        >
                            {{ $t('join_start_welcome') }} {{ name }}
                        </p>
                        <h1
                            class="theme-question-text-color theme-question-shadow text-white font-size-24 md:font-size-38 font-bold mt-0 mb-2 text-center"
                            v-html="title"
                        ></h1>
                        <h2
                            class="theme-question-text-color theme-question-shadow text-center text-white font-normal font-size-18 whitespace-pre-wrap"
                            v-html="description"
                        ></h2>
                        <div class="mt-4 mb-4">
                            <div v-if="image && image.length" class="flex items-center justify-center">
                                <div
                                    :style="{ 'background-image': 'url(' + image + ')' }"
                                    class="layout-title-img w-48 h-48 md:w-64 md:h-64 border-ui-style bg-cover bg-center bg-norepeat"
                                ></div>
                            </div>
                        </div>
                        <div class="text-center">
                            <p
                                class="theme-question-text-color theme-question-shadow font-bold text-white font-size-26 font-bold uppercase break-words"
                            >
                                {{ customMessage }}
                            </p>
                        </div>
                        <div class="mt-2 flex items-center justify-center h-32">
                            <div style="height: 60%">
                                <p
                                    class="theme-question-text-color theme-question-shadow text-white text-center font-size-26 font-bold uppercase"
                                >
                                    {{ $t('join_start_joined') }}
                                </p>
                                <p
                                    class="theme-question-text-color theme-question-shadow text-white text-center font-size-38 font-bold uppercase"
                                >
                                    {{ users.length }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer">
                    <div class="block md:hidden flex items-center flex-col justify-center w-full h-full">
                        <!-- <button :disabled="isNextEnable" @click="start" class="btn btn-large uppercase text-2xl">Next</button> -->
                        <p
                            v-if="isNextEnable"
                            class="theme-ui-text-color theme-question-shadow mt-2 text-white font-size-18 font-bold"
                        >
                            {{ $t('join_start_wait') }}
                        </p>
                        <p
                            v-if="!isNextEnable"
                            class="theme-ui-text-color theme-question-shadow mt-2 text-white font-size-18 font-bold"
                        >
                            {{ $t('join_start_ready') }}
                        </p>
                    </div>

                    <!-- Begin Desktop footer -->
                    <DesktopFooter>
                        <template slot="left">
                            <div class="flex items-end h-12">
                                <p
                                    v-if="isNextEnable"
                                    class="theme-ui-text-color theme-question-shadow mt-2 text-white font-size-18 font-bold"
                                >
                                    {{ $t('join_start_wait') }}
                                </p>
                                <p
                                    v-if="!isNextEnable"
                                    class="theme-ui-text-color theme-question-shadow mt-2 text-white font-size-18 font-bold"
                                >
                                    {{ $t('join_start_ready') }}
                                </p>
                            </div>
                        </template>
                        <template slot="right">
                            <div class="relative">
                                <!-- <button :disabled="isNextEnable" @click="start"  style="top: 0; right: -45px" class="absolute btn btn-large uppercase text-3xl">Next</button> -->
                            </div>
                        </template>
                    </DesktopFooter>
                    <!-- End Desktop footer -->
                </div>
                <before-quiz-modal v-if="isShowModal" @close="goNext"></before-quiz-modal>
            </section>
        </template>
    </ResizeScale>
</template>

<script>
import HeaderLogo from '@/components/HeaderLogo.vue'
import DesktopFooter from '@/components/DesktopFooter.vue'
import { mapState, mapGetters } from 'vuex'
import popup from '@/lib/popup.js'
import Background from '@/lib/background.js'
import ResizeScale from '@/components/ResizeScale.vue'
import preloadSongMixin from '@/mixins/preload-song'
import { currentUser, isLoggedIn } from '@/lib/user.js'
import Request from '@/lib/request.js'
import appConfig from '@/app.config.js'
import helperMixins from '@/mixins/helper.js'
import BeforeQuizModal from '@/components/BeforeQuizModal.vue'
import socketConnectionMixin from '@/mixins/socket-connection.js'
import { playerSocketSetting } from '@/mixins/live-quiz-socket.js'

export default {
    metaInfo() {
        return {
            link: [
                {
                    rel: 'stylesheet',
                    href: `${process.env.VUE_APP_ROOT_URL}style/dynamic/quiz/${
                        this.code
                    }.css?rand=${new Date().getTime()}`,
                    type: 'text/css'
                }
            ]
        }
    },

    components: {
        HeaderLogo,
        DesktopFooter,
        ResizeScale,
        BeforeQuizModal
    },

    mixins: [preloadSongMixin, helperMixins, socketConnectionMixin],

    sockets: {
        master_pressed_start: function (data) {
            this.$store.commit('player/setMasterPlayingAs', data.master_playing_as)

            this.isNextEnable = false
            this.isAllowToPressNext = true
            if (this.playerSound.effectMusic) {
                this.audioPlucky.play()
            }

            if (typeof navigator.vibrate !== 'undefined') {
                navigator.vibrate(500)
            }

            const request = new Request(),
                payload = {
                    user_id: '',
                    name: this.name,
                    master_user_id: data.quiz.master_user_id
                }

            if (isLoggedIn()) {
                payload.user_id = currentUser().id
                payload.name = currentUser().name

                request.post(appConfig.api.setUserPlayType.replace(/__id__/, currentUser().id), {
                    playing_type: 'play_together'
                })
            }

            request.post(appConfig.api.playWith, payload)

            // let hasMusicQuestion = this.quiz.questions.filter((question) => {
            //     return question.question_type === 'music'
            // }).length > 0

            // if (hasMusicQuestion) {
            //     this.isShowModal = true
            // } else {
            this.$router.push({
                name: 'countdown',
                params: {
                    code: this.code,
                    name: 'join-start'
                }
            })
            // }
        },

        master_pressed_next: function () {
            this.$store.dispatch('player/handleNextQuestionIndex')
            this.$router.push({
                name: 'redirect-quiz',
                params: {
                    code: this.code
                }
            })

            this.isAllowToPressNext = true
            this.audio.play()
        },

        master_pressed_end: function () {
            let txtType =
                this.type === 'poll'
                    ? this.firstUppercase(this.$t('playlive_share_type_poll'))
                    : this.firstUppercase(this.$t('playlive_share_type_quiz'))

            popup.alert(
                this.$t('playlive_alert_done', { type: txtType }),
                function () {
                    this.$router.replace({
                        name: 'summary'
                    })
                }.bind(this)
            )
        },

        user_joined_waiting_count: function (users) {
            this.users = users
        },

        master_ended_game: function () {
            let txtType =
                this.type === 'poll' ? this.$t('playlive_share_type_poll') : this.$t('playlive_share_type_quiz')

            popup.alert(this.$t('playlive_alert_cancelled', { type: txtType }), function () {
                window.location.href = '/join'
            })
        },

        user_ended_game: function (data) {
            this.users = data.users
        },

        update_questions: function (data) {
            this.updateQuestions(data.questions)
        },

        ...playerSocketSetting
    },

    created() {
        if (!document.querySelector('#dynamic-css')) {
            this.addStyleSheet(this.code)
        }
    },

    mounted: function () {
        this.touchActionNone()

        window.onbeforeunload = function () {
            return 'Are you sure you want to leave this page? You will loose any unsaved actions'
        }

        this.$socket.emit('user_joined_waiting', {
            room: this.code
        })

        window.addEventListener('unload', this.handleUserCloseWindow)

        new Background({
            color: this.quiz.theme_name
                ? this.quiz.themes[this.quiz.theme_name].background_color
                : this.backgroundColor,
            image: this.quiz.theme_name
                ? this.quiz.themes[this.quiz.theme_name].background_image
                : this.backgroundImage,
            type: this.backgroundType,
            blur: this.blur,
            darken: this.darken,
            navText: this.frontPageSetting.nav_text,
            useTheme: this.quiz.theme_name ? true : false
        })

        this.preloadNextSong(this.quiz.questions[0])

        this.$store.commit('player/clearCoin')

        this.$store.dispatch('getQuizRelateCategory', { tags: this.tags, quiz_id: this.fromQuizIdPlayer })
    },

    destroyed() {
        window.onbeforeunload = function () {}
    },

    data: function () {
        return {
            isNextEnable: true,
            isShowModal: false,
            users: [],
            isAllowToPressNext: false,
            audio: document.getElementById('audio')
        }
    },

    methods: {
        start: function (e) {
            if (!this.isAllowToPressNext) {
                return typeof e.preventDefault == 'function' ? e.preventDefault() : null
            }

            this.$router.push({
                name: 'quiz',
                params: {
                    code: this.code
                }
            })
        },

        handleUserCloseWindow: function () {
            this.$socket.emit('user_end_game', {
                room: this.code,
                name: this.name,
                remove_user: false
            })
        },

        goNext() {
            this.isShowModal = false
            this.$router.push({
                name: 'countdown',
                params: {
                    code: this.code,
                    name: 'join-start'
                }
            })
        },

        updateQuestions(questions) {
            this.$store.commit('player/updateManyQuestion', questions)
        }
    },

    computed: {
        ...mapGetters({
            audioPlucky: 'getPluckyAudio',
            playerSound: 'player/getPlayerSound',
            playerQuestion: 'getPlayerQuestion'
        }),

        ...mapState({
            quiz: state => state.player.quiz,
            image: state => state.player.quiz.image,
            name: state => state.player.name,
            title: state => state.player.quiz.title,
            code: state => state.player.quiz.code,
            type: state => state.player.quiz.type,
            description: state => state.player.quiz.description,
            backgroundType: state => state.player.quiz.background_type,
            backgroundColor: state => state.player.quiz.background_color,
            backgroundImage: state => state.player.quiz.background_image,
            blur: state => state.player.quiz.background_image_blur,
            darken: state => state.player.quiz.background_image_darken,
            playingStatus: state => state.player.isPlaying,
            customMessage: state => state.player.quiz.custom_message,
            tags: state => state.player.quiz.tags,
            fromQuizIdPlayer: state => state.player.quiz.from_quiz_id,
            frontPageSetting: state => state.frontPageSetting
        })
    },

    beforeRouteLeave(to, from, next) {
        window.onbeforeunload = function () {}

        if (to.name === 'countdown') {
            next()
        } else {
            next(false)
            popup.confirm(
                this.$t('playlive_alert_leave'),
                function () {
                    window.location.href = '/join'
                },
                function () {
                    window.onbeforeunload = function () {
                        return 'Are you sure you want to leave this page? You will loose any unsaved actions'
                    }
                }
            )
        }
    }
}
</script>

<style lang="scss" scoped>
#join-start-section {
    .logo {
        @media (max-width: 768px) {
            max-width: 9rem !important;
        }
    }
}
</style>
